module.exports = __webpack_public_path__ + "static/img/qiyebanner.d64e4ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/qiyebanner.jpg
// module id = Y8BL
// module chunks = 1